import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-choose-program',
  templateUrl: './choose-program.component.html',
  styleUrl: './choose-program.component.less'
})
export class ChooseProgramComponent implements OnInit {

  @Input() landingCMSData: any;

  cardData: any = [];
  
  constructor() {}

  ngOnInit(): void {

    this.landingCMSData.whyToChooseProgramCards.forEach((element: any) => {
      this.cardData.push(element);
    });
  }
}
